import { AuthenticatedAPI } from '../../core-apis/src/apis/config/api/authenticatedApi'
import { UnauthenticatedAPI } from '../../core-apis/src/apis/config/api/unauthenticatedApi'
import { BasicAPI } from '../../core-apis/src/apis/config/api/basicApi'

const WIGGOT_API_LEGACY_URL = process.env.WIGGOT_API_LEGACY ?? ''
const LISTINGS_URL_API = process.env.LISTINGS_URL_API ?? ''
class LegacyApiAuth extends AuthenticatedAPI {
  constructor() {
    super({
      domain: WIGGOT_API_LEGACY_URL
    })
  }
}

class LegacyApiBasic extends UnauthenticatedAPI {
  constructor() {
    super({
      domain: WIGGOT_API_LEGACY_URL
    })
  }
}

class MonopolioApi extends BasicAPI {
  constructor() {
    super({
      domain: LISTINGS_URL_API
    })
  }
}

export const legacyApiAuth = new LegacyApiAuth()
export const legacyApiBasic = new LegacyApiBasic()
export const monopolioApi = new MonopolioApi()
